export default __webpack_public_path__ + "static/media/58t.a59bc432.jpg";